import React from 'react';

import { Box } from '@wds/box';
import Package from '../components/Package';
import SocialProof from '../components/SocialProof';
import MainHeading from '~pricing/components/MainHeading';
import SummaryFooter from '~pricing/components/PricingFooter';

import { Packages } from '~shared/constants/pricing';
import useSummaryStyles from './useStyles';
import { usePricingState } from '~shared/hooks/usePricingState';
import { PricingPackage } from '~shared/types/pricing/pricingsvc';

export default function PricingSummaryPage(): JSX.Element {
  const { PackagesContainer, Summary } = useSummaryStyles();
  const {
    state: {
      packages: { comparePlans, discountInfo, displayPackages, allPackages },
    },
  } = usePricingState();

  const filteredPackages = displayPackages?.filter(pkg => pkg?.packageName !== Packages.Basic);

  function getPackage(pricingPackage: PricingPackage, index: number): JSX.Element {
    const props = {
      ...pricingPackage,
      comparisonSkuCost: pricingPackage.comparisonSkuCost || [],
      comparePlans,
      discountInfo,
      key: `package-${pricingPackage.packageName}`,
      isLastPackage: index + 1 === filteredPackages.length,
    };

    return <Package {...props} />;
  }

  return (
    <div key="PricingSummary">
      <header>
        <MainHeading variant="pageTitle" />
        <SocialProof />
      </header>
      <Box className={Summary}>
        <Box className={PackagesContainer}>
          {filteredPackages.length &&
            filteredPackages?.map(
              (pricingPackage, index: number) => pricingPackage && getPackage(pricingPackage, index)
            )}
        </Box>
        <SummaryFooter packages={allPackages} />
      </Box>
    </div>
  );
}
